export const srcSetWidths = [565, 610, 750, 800, 1200, 1920, 2880, 3840];

export const generateSrcSet = (src: string, loader: any, sizes?: number[]) => {
  const createSizes = sizes || srcSetWidths;
  const srcSet = createSizes.map(size => `${loader({ src, width: size })} ${size}w`);
  return srcSet.join(', ');
};
